import { ChangeEvent, FC, ReactNode, useCallback, useContext } from 'react';
import { ListboxContext } from './ListboxContext';
import { useDebouncedCallback } from '@apia/util';
import { Box, BoxProps, Input } from '@apia/theme';

const Combobox: FC<{ children: ReactNode } & BoxProps> = ({
  children,
  ...props
}) => {
  const { id, listboxActions, useListbox } = useContext(ListboxContext);
  const run = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    listboxActions.filter({ searchString: ev.target.value });
  });

  const ref = useListbox<HTMLInputElement>('searchbox', null);

  return (
    <>
      <Input
        ref={ref}
        type="text"
        id={`${id}__searchbox`}
        placeholder="Search..."
        aria-autocomplete="list"
        aria-controls={`${id}__list__container`}
        role="combobox"
        aria-expanded
        aria-haspopup="listbox"
        onChange={run}
        autoComplete="off"
      />
      <Box
        as="ul"
        id={`${id}__list__container`}
        role="listbox"
        className="listbox__list"
        {...props}
        onClick={useCallback(() => {
          if (
            document.activeElement !==
            document.getElementById(`${id}__searchbox`)
          )
            document.getElementById(`${id}__searchbox`)?.focus();
        }, [id])}
      >
        {children}
      </Box>
    </>
  );
};

export { Combobox };
